import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  VOID7hggqo3abtya as VOID,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  KProperty02ce7r476m8633 as KProperty0,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  lazy2hsh8ze7j6ikd as lazy,
} from './kotlin-kotlin-stdlib.mjs';
import { Dispatchers_getInstance2xomc0oxzllw9 as Dispatchers_getInstance } from './kotlinx-coroutines-core.mjs';
//region block: imports
//endregion
//region block: pre-declaration
class Companion {
  constructor() {
    Companion_instance = this;
    this.u24_1 = get_defaultSystemFS();
  }
}
class NullSyncSystemFS {}
class toAsync$1 {
  constructor($ioDispatcher, $sync) {
    this.v24_1 = $ioDispatcher;
    this.w24_1 = $sync;
  }
}
//endregion
function get_NullSystemFS() {
  _init_properties_SystemFS_kt__ntwqsk();
  return NullSystemFS;
}
var NullSystemFS;
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new Companion();
  return Companion_instance;
}
function toAsync(_this__u8e3s4, ioDispatcher) {
  _init_properties_SystemFS_kt__ntwqsk();
  var sync = _this__u8e3s4;
  return new toAsync$1(ioDispatcher, sync);
}
var NullSyncSystemFS_instance;
function NullSyncSystemFS_getInstance() {
  return NullSyncSystemFS_instance;
}
var properties_initialized_SystemFS_kt_k4cs8u;
function _init_properties_SystemFS_kt__ntwqsk() {
  if (!properties_initialized_SystemFS_kt_k4cs8u) {
    properties_initialized_SystemFS_kt_k4cs8u = true;
    NullSystemFS = toAsync(NullSyncSystemFS_instance, Dispatchers_getInstance().z1c_1);
  }
}
var defaultSyncSystemFS;
function get_defaultSystemFS() {
  _init_properties_SystemFS_js_kt__9f6y2x();
  // Inline function 'kotlin.getValue' call
  var this_0 = defaultSystemFS$delegate;
  defaultSystemFS$factory();
  return this_0.n1();
}
var defaultSystemFS$delegate;
function defaultSystemFS$delegate$lambda() {
  _init_properties_SystemFS_js_kt__9f6y2x();
  return get_NullSystemFS();
}
function defaultSystemFS$factory() {
  return getPropertyCallableRef('defaultSystemFS', 0, KProperty0, function () {
    return get_defaultSystemFS();
  }, null);
}
var properties_initialized_SystemFS_js_kt_5tdsz9;
function _init_properties_SystemFS_js_kt__9f6y2x() {
  if (!properties_initialized_SystemFS_js_kt_5tdsz9) {
    properties_initialized_SystemFS_js_kt_5tdsz9 = true;
    defaultSyncSystemFS = NullSyncSystemFS_instance;
    defaultSystemFS$delegate = lazy(defaultSystemFS$delegate$lambda);
  }
}
//region block: post-declaration
initMetadataForCompanion(Companion, VOID, VOID, [2, 1, 3]);
initMetadataForObject(NullSyncSystemFS, 'NullSyncSystemFS');
initMetadataForClass(toAsync$1, VOID, VOID, VOID, VOID, [1, 2, 3]);
//endregion
//region block: init
NullSyncSystemFS_instance = new NullSyncSystemFS();
//endregion
//region block: exports
export {
  Companion_getInstance as Companion_getInstance1vfndg47rf0,
};
//endregion
